import { constants } from './config';

export const postServiceProductOrder = (data) => ({
  type: constants.POST_SERVICE_PRODUCT_ORDER,
  payload: data,
});

export const postServiceProductOrderSuccess = (data) => ({
  type: constants.POST_SERVICE_PRODUCT_ORDER_SUCCESS,
  payload: data,
});

export const postServiceProductOrderFail = (error) => ({
  type: constants.POST_SERVICE_PRODUCT_ORDER_FAIL,
  payload: error,
});

export const putServiceProductOrder = (data) => ({
  type: constants.PUT_SERVICE_PRODUCT_ORDER,
  payload: data,
});

export const putServiceProductOrderSuccess = (data) => ({
  type: constants.PUT_SERVICE_PRODUCT_ORDER_SUCCESS,
  payload: data,
});

export const putServiceProductOrderFail = (error) => ({
  type: constants.PUT_SERVICE_PRODUCT_ORDER_FAIL,
  payload: error,
});

export const resetServiceProductOrder = () => ({
  type: constants.RESET_SERVICE_PRODUCT_ORDER,
});

export const getServiceProductOrderFromSockets = (data) => ({
  type: constants.GET_SERVICE_PRODUCT_ORDER_FROM_SOCKETS,
  data,
});
